import React from 'react';
import {AvGroup} from "availity-reactstrap-validation";
import {Col, Label, Row} from "reactstrap";
import AvField from "../../shared/component/form/AvField";
import CityService from "../../shared/service/CityService";

const defaultTtRegion = {
    id: '',
    cityId: 1,
    ttRegionName: ''
    
};
export default class TtRegionSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ttRegion: defaultTtRegion,
            cityList: [],
            pageMode: null
        };
        this.cityService = new CityService();
    }
    componentDidMount = () => {
        this.clearData();
        this.cityService.findAll().then(response => this.setState({cityList: response}));
    }

    render() {
        return (
            <Row className="justify-content-center">
                <Col>
                    <AvGroup>
                        <Label for="cityId">İl Adı<span style={{color: 'red'}}> (*)</span>
                        </Label>
                        <AvField
                            type="select"
                            className="form-control"
                            name="cityId"
                            value={this.state.ttRegion.cityId}
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'Bu alan zorunlu.'
                                }
                            }}
                            onChange={this.__handleChange}>
                        {this.state.cityList.map(element => (
                            <option value={element.id} key={element.id}>
                                {element.name}
                            </option>
                        ))}
                        </AvField>
                    </AvGroup>
                    <AvGroup>
                        <Label for="ttRegionName">TT Bölge<span style={{color: 'red'}}> (*)</span>
                        </Label>
                        <AvField
                            type="text"
                            className="form-control"
                            name="ttRegionName"
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'Bu alan zorunlu.'
                                },
                                minLength: {
                                    value: 1,
                                    errorMessage: 'Bu alan en az 1 karakterden oluşabilir.'
                                },
                                maxLength: {
                                    value: 50,
                                    errorMessage: 'Bu alan en fazla 50 karakterden oluşabilir.'
                                }
                            }}
                            value={this.state.ttRegion.ttRegionName}
                            onChange={this.__handleChange}
                        />
                    </AvGroup>
                    
                </Col>
            </Row>
        );
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let ttRegion = this.state.ttRegion;
        ttRegion[e.target.name] = value;
        this.setState({ttRegion: ttRegion});
    }

    setData = (data, pageMode) => {
        data.cityId = data.cityId ? data.cityId.id : null;
        this.setState({ttRegion: data, pageMode: pageMode});
    }

    getData = () => {
        return this.state.ttRegion;
    }

    clearData = () => {
        this.setState({ttRegion: Object.assign({}, defaultTtRegion), pageMode: null});
    }

}
